export default __webpack_public_path__ + "static/stanleyknife-66112ce5dcc448896a4460baa8579e6a.png";